function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { formatNumber } from "../../utils/formatNumber";
var styles = {
    container: {
        width: "100%",
        height: "auto",
        padding: "64px 20px 64px 20px",
        gap: "40px",
        "border-radius": "32px",
        opacity: "0px",
        maxWidth: "600px",
        "background-color": "#EBE4D5"
    },
    title: {
        "font-family": "Helvetica",
        "font-size": "28px",
        "font-weight": 700,
        "line-height": "33.6px",
        "text-align": "center",
        color: "#272835"
    },
    subtitle: {
        "font-family": "Helvetica",
        "font-size": "14px",
        "font-weight": 400,
        "line-height": "19.6px",
        "text-align": "center",
        color: "#272835"
    },
    text: {
        "font-family": "Helvetica",
        "font-size": "14px",
        "font-weight": 400,
        "line-height": "19.6px",
        "text-align": "center",
        color: "#272835"
    },
    tableTitle: {
        "font-family": "Helvetica",
        "font-size": "28px",
        "font-weight": 700,
        "line-height": "33.6px",
        "text-align": "left",
        "margin-top": "40px",
        color: "#272835"
    },
    tableSubtitle: {
        "font-family": "Helvetica",
        "font-size": "14px",
        "font-weight": 400,
        "line-height": "19.6px",
        "text-align": "left",
        color: "#272835"
    },
    tableContainer: {
        width: "100%"
    },
    table: {
        width: "100%",
        "border-radius": "16px",
        "margin-top": "20px",
        overflow: "hidden"
    },
    tableHead: {
        "background-color": "#3A8574"
    },
    tableBody: {},
    tableFooter: {},
    tableRow: {},
    tableCell: {}
};
var renderContainer = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<div style="'.concat(Object.entries(_object_spread({}, styles.container, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</div>");
};
var renderTitle = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<div style="'.concat(Object.entries(_object_spread({}, styles.title, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</div>");
};
var renderText = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<p style="'.concat(Object.entries(_object_spread({}, styles.text, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</p>");
};
var renderSubtitle = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<p style="'.concat(Object.entries(_object_spread({}, styles.subtitle, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</p>");
};
var renderTableContainer = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<div style="'.concat(Object.entries(_object_spread({}, styles.tableContainer, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</div>");
};
var renderTableTitle = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<div style="'.concat(Object.entries(_object_spread({}, styles.tableTitle, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</div>");
};
var renderTableSubtitle = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<p style="'.concat(Object.entries(_object_spread({}, styles.tableSubtitle, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</p>");
};
var renderTable = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<table style="'.concat(Object.entries(_object_spread({}, styles.table, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</table>");
};
var renderTableHead = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<thead style="'.concat(Object.entries(_object_spread({}, styles.tableHead, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</thead>");
};
var renderTableHeader = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<th style="'.concat(Object.entries(_object_spread({}, styles.tableCell, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</th>");
};
var renderTableBody = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<tbody style="'.concat(Object.entries(_object_spread({}, styles.tableBody, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</tbody>");
};
var renderTableRow = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<tr style="'.concat(Object.entries(_object_spread({}, styles.tableRow, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</tr>");
};
var renderTableCell = function(children) {
    var style = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return '<td style="'.concat(Object.entries(_object_spread({}, styles.tableCell, style)).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ":").concat(value);
    }).join(";"), '">').concat(children, "</td>");
};
export var renderEmailContent = function(param) {
    var t = param.t, data = param.data;
    var dataContent = "";
    if (data.dataWithLegacy.length > 0) {
        var tableWithLegacyBody = data.dataWithLegacy.map(function(item, index) {
            return "\n        ".concat(renderTableRow("\n          ".concat(renderTableCell("\n            ".concat(renderText(t(item.relation), {
                "text-align": "left"
            }), "\n            ").concat(renderText(item.name, {
                opacity: 0.5,
                "text-align": "left"
            }), "\n          ")), "\n          ").concat(renderTableCell(formatNumber(Number(item.legacy))), "\n          ").concat(!item["inheritance-rights"] ? renderTableCell("/") : renderTableCell("\n              ".concat(item["inheritance-rights"].map(function(right) {
                return "\n                ".concat(renderText("-".concat(formatNumber(Number(right.value))), {
                    "text-align": "left"
                }), "\n                ").concat(renderText(t("droits_de") + t(right.relationship), {
                    opacity: 0.8,
                    "text-align": "left"
                }), "\n              ");
            }).join(""), "\n            ")), "\n          ").concat(renderTableCell(formatNumber(Number(item.net))), "\n          ").concat(renderTableCell(Number(item.advantage) > 0 ? "+".concat(formatNumber(Number(item.advantage))) : formatNumber(Number(item.advantage)), {
                color: Number(item.advantage) > 0 ? "#3a8574" : "#ff5055"
            }), "\n        "), _object_spread({}, index === data.dataWithLegacy.length - 1 && {
                "border-bottom": "none"
            })));
        });
        dataContent += renderTableContainer("\n      ".concat(renderTableTitle("".concat(t("simulation-result"), " ").concat(t(data.region))), "\n      ").concat(renderTableTitle(t("with-legacy-as-a-duo")), "\n      ").concat(renderTableSubtitle(t("compare-the-advantage-for-each-inheritance-with-duo-legacy")), "\n      ").concat(renderTable("\n        ".concat(renderTableHead("\n          ".concat(renderTableRow("\n            ".concat(renderTableHeader(""), "\n            ").concat(renderTableHeader(t("legacy")), "\n            ").concat(renderTableHeader(t("inheritance-rights")), "\n            ").concat(renderTableHeader(t("net")), "\n            ").concat(renderTableHeader(t("advantage")), "\n          ")), "\n        ")), "\n        ").concat(renderTableBody(tableWithLegacyBody.join("")), "\n      ")), "\n    "));
    }
    if (data.dataWithoutLegacy.length > 0) {
        var tableWithoutLegacyBody = data.dataWithoutLegacy.map(function(item, index) {
            return "\n        ".concat(renderTableRow("\n          ".concat(renderTableCell("\n            ".concat(renderText(t(item.relation), {
                "text-align": "left"
            }), "\n            ").concat(renderText(item.name, {
                opacity: 0.5,
                "text-align": "left"
            }), "\n          ")), "\n          ").concat(renderTableCell(formatNumber(Number(item.legacy))), "\n          ").concat(renderTableCell(!item["inheritance-rights"] ? "/" : formatNumber(Number(item["inheritance-rights"]))), "\n          ").concat(renderTableCell(!item.net ? "/" : formatNumber(Number(item.net))), "\n          ").concat(renderTableCell(!item.advantage ? "" : item.advantage === "/" ? item.advantage : Number(item.advantage) > 0 ? "+".concat(formatNumber(Number(item.advantage))) : "".concat(formatNumber(Number(item.advantage))), {
                color: "#ff5055"
            }), "\n        "), _object_spread({}, index === data.dataWithoutLegacy.length - 1 && {
                "border-bottom": "none"
            })));
        });
        dataContent += renderTableContainer("\n      ".concat(renderTableTitle(t("without-legacy-as-a-duo")), "\n      ").concat(renderTableSubtitle(t("compare-the-advantage-for-each-inheritance-without-duo-legacy")), "\n      ").concat(renderTable("\n        ".concat(renderTableHead("\n          ".concat(renderTableRow("\n            ".concat(renderTableHeader(""), "\n            ").concat(renderTableHeader(t("legacy")), "\n            ").concat(renderTableHeader(t("inheritance-rights")), "\n            ").concat(renderTableHeader(t("net")), "\n            ").concat(renderTableHeader(""), "\n          ")), "\n        ")), "\n        ").concat(renderTableBody(tableWithoutLegacyBody.join("")), "\n      ")), "\n    "));
    }
    if (data.dataWithoutDuo.length > 0) {
        var tableWithoutDuoBody = data.dataWithoutDuo.map(function(item, index) {
            return "\n        ".concat(renderTableRow("\n          ".concat(renderTableCell("\n            ".concat(renderText(t(item.relation), {
                "text-align": "left"
            }), "\n            ").concat(renderText(item.name, {
                opacity: 0.5,
                "text-align": "left"
            }), "\n          ")), "\n          ").concat(renderTableCell(formatNumber(Number(item.legacy))), "\n          ").concat(renderTableCell(!item["inheritance-rights"] ? "/" : formatNumber(Number(item["inheritance-rights"]))), "\n          ").concat(renderTableCell(!item.net ? "/" : formatNumber(Number(item.net))), "\n        "), _object_spread({}, index === data.dataWithoutDuo.length - 1 && {
                "border-bottom": "none"
            })));
        });
        dataContent += renderTableContainer("\n      ".concat(renderTableTitle("".concat(t("simulation-result"), " ").concat(t(data.region))), "\n      ").concat(renderTable("\n        ".concat(renderTableHead("\n          ".concat(renderTableRow("\n            ".concat(renderTableHeader(""), "\n            ").concat(renderTableHeader(t("legacy")), "\n            ").concat(renderTableHeader(t("inheritance-rights")), "\n            ").concat(renderTableHeader(t("net")), "\n          ")), "\n        ")), "\n        ").concat(renderTableBody(tableWithoutDuoBody.join("")), "\n      ")), "\n    "));
    }
    var content = renderContainer("\n    ".concat(renderSubtitle(t("export_description")), "\n    ").concat(dataContent, "\n  "));
    var footer = renderContainer("\n    ".concat(renderTitle(t("contact")), "\n    ").concat(renderText("".concat(t("by-email"), ' : <strong><a href="mailto:legs@deduveinstitute.be">legs@deduveinstitute.be</a></strong>')), "\n    ").concat(renderText("".concat(t("or-by-phone"), ' <strong><a href="tel:+3227647334">+32 2 764 73 34</a></strong> (').concat(t("direct-line"), ")")), "\n  "), {
        "margin-top": "40px"
    });
    return "".concat(content).concat(footer);
};
export default renderEmailContent;

//# sourceMappingURL=renderEmailContent.js.map